module.exports = __webpack_public_path__ + "img/gr.7e0d3c88.png";